
import { FormlyFieldConfig } from '@ngx-formly/core';
import { differenceInDays, isAfter } from 'date-fns';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Employee, ImmigrationApi, ImmigrationProfile, LookupField, RoleType } from 'src/app/core/api.gen';
import { CommonService } from "src/app/core/common.service";
import { CountryTypeIds, CountryTypesValues } from "src/app/immigration/services/visatypes/country-types.enum";
import {
  checkRange,
    getConfigurableTypeAhead, getDateField,
    getEmpProfileSelectField, getInputField,
    getJustaButton, getMergedConfig, getSelectField,
    getTypeAheadField, setAsDisabled, setAsNumeric, setAsRequired,
    setDisableWhen, setHideButtonWhen, setImmStatusTypeValidation, setRegexValidation,setRequiredWhen,getTelephoneField,setAsRequiredEmail,
    setAsHiddenWithoutValueWhen,
    setDisablewithValueWhen
} from 'src/app/shared/form';
import { LookupTypeKeys } from "src/app/shared/lookup-type-keys";
import { ImmStatusType } from 'src/app/shared/status-types';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined, isUndefined } from '../../../../app/core/utils';
import { FieldTooltip } from './field-tooltip.enum';

export class CommonVisaInputs {

  protected onBoardingTypes$: Observable<LookupField[]>;
  protected nationality$: Observable<LookupField[]>;
  protected gender$: Observable<LookupField[]>;
  protected officeLocation$: Observable<LookupField[]>;
  //same as officeLocation$
  protected officeLocationWithBehaviourSub$: Observable<LookupField[]>;
  protected visaAlignment$: Observable<LookupField[]>;
  protected officeLE$: Observable<LookupField[]>;
  protected serviceLines$: Observable<LookupField[]>;
  protected subServiceLines$: Observable<LookupField[]>;
  protected subSubServiceLines$: Observable<LookupField[]>;
  protected ranks$: Observable<LookupField[]>;
  protected officeLocationCountry$: Observable<LookupField[]>;
  protected immigrationCaseType$: Observable<LookupField[]>;
  protected immigrationCaseTypeVisaPreApproval$: Observable<LookupField[]>;
  protected immigrationCaseTypeTempPartWP_ARE$: Observable<LookupField[]>;
  protected entryType$: Observable<LookupField[]>;
  protected getVisaDuration$: Observable<LookupField[]>;
  protected purposeOfVisit$: Observable<LookupField[]>; 
  protected workLocationDuringTrip$: Observable<LookupField[]>;
  protected processingTeam$: Observable<LookupField[]>;
  protected requiredAttestation$: Observable<LookupField[]>;
  protected processingBy$: Observable<LookupField[]>;
  protected residencyStatus$: Observable<LookupField[]>;
  protected ptcs$: Observable<Employee[]>;
  profileDataFromGui = new Subject<ImmigrationProfile>();
  protected allOfficeLocation$: Observable<LookupField[]>;
  protected allOfficeLocationCountry$: Observable<LookupField[]>;
  protected allForeignOfficeLocation$: Observable<LookupField[]>;
  protected businessVisaDurationOfStay$: Observable<LookupField[]>;
  protected globalEmployeeLocationCountries$: Observable<LookupField[]>;
  protected workpermitJobTitles$: Observable<LookupField[]>;

  protected recruiters$: Observable<Employee[]>;
  protected localHre$: Observable<Employee[]>;
  protected visaCancellationRequestors$: Observable<Employee[]>;
  protected visaApprovers$: Observable<Employee[]>;
  protected yesNo$: Observable<LookupField[]>;
  protected accommodationRequired$: Observable<LookupField[]>;
  protected requestedServices$: Observable<LookupField[]>;
  protected employees$: Observable<Employee[]>;
  protected gosiRemovalRequesters$: Observable<Employee[]>;
  protected exitIqamaTransfer$: Observable<Employee[]>;
  protected transferScenario$: Observable<LookupField[]>;
  protected employeeCategorys$: Observable<LookupField[]>;
  protected typeOfEmployment$: Observable<LookupField[]>;

  protected officeLegalEntities$: Observable<Employee[]>;
  protected preboardingType$: Observable<Employee[]>;
  protected cancellationReason$: Observable<LookupField[]>;

  protected visaPreApprovalrequestors$: Observable<LookupField[]>;
  protected gosiAdditionRequestors$: Observable<LookupField[]>;
  protected ImmStatus$: Observable<LookupField[]>;
  protected passportType$: Observable<LookupField[]>;

  protected enrollmentType$: Observable<LookupField[]>;
  protected workTimings$: Observable<LookupField[]>;
  protected language$: Observable<LookupField[]>;
  protected workWeek$: Observable<LookupField[]>;
  protected jobBenefits$: Observable<LookupField[]>;

  protected religion$: Observable<LookupField[]>;
  protected sect$: Observable<LookupField[]>;
  protected missionVisaType$: Observable<LookupField[]>;
  protected molContract$: Observable<LookupField[]>;

  protected omnWorkPermitPreApproval$: Observable<LookupField[]>;
  protected maritalStatus$: Observable<LookupField[]>;
  protected shortTermVisa$: Observable<LookupField[]>;
  protected relationship$: Observable<LookupField[]>;
  protected typeOfRequest$: Observable<LookupField[]>;
  protected currentVisaStatus$: Observable<LookupField[]>;

  protected cprCaseType$: Observable<LookupField[]>;
  protected cprType$: Observable<LookupField[]>;
  protected reasonForVisit$: Observable<LookupField[]>;
  protected JORReasonForVisit$: Observable<LookupField[]>;
  protected hireType$: Observable<LookupField[]>;
  protected tawteenRequesters$: Observable<Employee[]>;
  protected PensionRemovalRequesters$: Observable<Employee[]>;
  protected yesNoNa$: Observable<LookupField[]>;
  protected laborCardCancellationRequesters$: Observable<Employee[]>;
  protected visaCancellationInsideRequesters$: Observable<Employee[]>;
  protected visaCancellationOutsideRequesters$: Observable<Employee[]>;
  protected dependentsVisaIssuanceRequesters$: Observable<Employee[]>;
  protected dependentsVisaRenewalRequesters$: Observable<Employee[]>;
  protected depVisaGccMarriedToExpatRequesters$: Observable<Employee[]>;
  protected employmentVisaRenewalRequesters$: Observable<Employee[]>;

  protected permitType$: Observable<LookupField[]>;
  protected bloodGroup$: Observable<LookupField[]>;
  protected typeOfSupport$: Observable<LookupField[]>;
  protected typeOfModifcation$: Observable<LookupField[]>;
  protected missionVisaCategory$: Observable<LookupField[]>;
  protected missionVisaCategoryWithBehaviourSub$: Observable<LookupField[]>;
  protected academicQualification$: Observable<LookupField[]>;
  protected categoryOfJobOffer$: Observable<LookupField[]>;
  protected categoryOfJobOfferWithBehaviourSub$: Observable<LookupField[]>;
  protected reasonForVisitUAE$: Observable<LookupField[]>;
  protected reasonForRenewal$: Observable<LookupField[]>;
  protected travelType$: Observable<LookupField[]>;
  protected nomination$: Observable<LookupField[]>;
  protected labourcardcancellationtype$: Observable<LookupField[]>;
  protected terminationtype$: Observable<LookupField[]>;
  protected travelPurpose$: Observable<LookupField[]>;
  protected noofexteniontimes$: Observable<LookupField[]>;
  protected VaccinationStatus$: Observable<LookupField[]>;
  protected VaccineType$: Observable<LookupField[]>;
  protected typeOfDocRequested$: Observable<LookupField[]>;
  protected documentSupportType$: Observable<LookupField[]>;
  protected citizenship$: Observable<LookupField[]>;
  protected nationalityType$: Observable<LookupField[]>;
  protected currentKSAbusinessvisa$: Observable<LookupField[]>;
  protected reasonForVisitPAK$: Observable<LookupField[]>;
  protected pakOfficeToVisit$: Observable<LookupField[]>;
  protected typeOfVisa$: Observable<LookupField[]>;
  protected typeOfVisaRequired$: Observable<LookupField[]>;
  protected typeOfWorkPermit$: Observable<LookupField[]>;
  protected ksaOfficeLocation$: Observable<LookupField[]>;
  protected KsaLegalEntities$: Observable<LookupField[]>;
  protected primeType$: Observable<LookupField[]>;

    constructor(
    public common: CommonService,
    public immigration: ImmigrationApi) {
    this.loadCandidateLookups();
    }
    
    firstName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
      let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('First name', additionalConfig);
      return getInputField(
        "firstName",
        "First name (as per passport)",
        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', configWithTooltip))
      );
    }

  middleName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Middle name', additionalConfig);
    return getInputField(
      "middleName",
      "Middle name (as per passport)",
      setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', configWithTooltip)
    );
  }

  lastName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Last name', additionalConfig);
    return getInputField("lastName", "Last name (as per passport)",
      setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', configWithTooltip)));
  }

  // nationality(additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
  //   let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent nationality' :'Nationality', additionalConfig);
  //    return getSelectField(
  //       "nationality.id",
  //       "Nationality",
  //       this.common.getNationalityFieldOptionsBasedonNationality(true, setAsRequired(configWithTooltip))
  //   ); 
  // }
  bTnationalityType(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

  const configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Nationality type', additionalConfig);
  return getSelectField(
    "nationalityType.id",
    "Nationality type",
    this.common.getSelectFieldOptionsWithDisable(
      this.nationalityType$.pipe(
        map(item => item.filter(i => [14570, 14571, 14572].includes(i.id)))
      ),
      [14573],
      this.common.getBTNationalityTypeFieldOptionsBasedOnType(
        setAsRequired(configWithTooltip)
      )
    )
  );
}



  nationality(additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let tooltipConfig = this.addFieldTooltipWithAdditionalConfig(
      isDependent ? 'Dependent nationality' :'Nationality', 
      additionalConfig
    );
    let fieldConfig = setAsRequired(tooltipConfig);
    fieldConfig = {
      ...fieldConfig,
    };  
    return getSelectField(
      "nationality.id",
      "Nationality",
      this.common.getNationalityFieldOptionsBasedonNationality(true, fieldConfig) 
    ); 
  }
  nationalityDependent(): FormlyFieldConfig {
    let tooltipConfig = this.addFieldTooltipWithAdditionalConfig('Dependent nationality');
    let fieldConfig = setAsRequired(tooltipConfig);
    fieldConfig = {
      ...fieldConfig,
    };  
    return getSelectField(
      "nationality.id",
      "Nationality",
      this.common.getNationalityFieldOptionsBasedonNationality(true, fieldConfig)
    );
  } 
  categoryOfJobOffer(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("categoryOfJobOffer.id", "Category of job offer", this.common.getSelectFieldOptions(this.categoryOfJobOffer$, '',
      setAsRequired(additionalConfig)));
  }
  preboardingType(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("preboardingType.id", "Preboarding type", this.common.getSelectFieldOptions(this.preboardingType$, '',
      setAsRequired(additionalConfig)));
  }

  passportType(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Passport type', additionalConfig);
    return getSelectField("passportType.id", "Passport type", this.common.getSelectFieldOptions(this.passportType$, '',
      setAsRequired(configWithTooltip)));
  }


  passportNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Passport number', additionalConfig);
    return getInputField("passportNumber", "Passport number", setAsRequired(configWithTooltip));
  }

  nationalityIdNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
        let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('National id number', additionalConfig);
    return getInputField("nationalityIdNumber", "National id number", setAsRequired(configWithTooltip));
  }

  placeOfBirth(additionalConfig?: FormlyFieldConfig , isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent place of birth' :'Place of birth', additionalConfig);
    return getInputField("placeOfBirth", "Place of birth (City, Country)", setAsRequired(configWithTooltip));
  }

  currentRPDesignation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("currentRPDesignation", "Current RP designation", setAsRequired(additionalConfig));
  }

  currentSponcerName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("currentSponcerName", "Current sponsor name", setAsRequired(additionalConfig));
  }


  workPermitNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("workPermitNumber", "Work permit number", setAsRequired(additionalConfig));
  }

  dateOfBirth(additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent date of birth' :'Date of birth', additionalConfig);
    return getDateField("dateOfBirth", "Date of birth", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip)));
  }

  dateOfBirthOptional(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Date of birth', additionalConfig);
    return getDateField("dateOfBirth", "Date of birth", setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip));
  }
  
  gender(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("gender.id", "Gender", this.common.getSelectFieldOptions(this.gender$, '', setAsRequired(additionalConfig)));
  }
  emailAddress(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Email address', additionalConfig);
    return getInputField("emailAddress", "Email address", setAsRequiredEmail(configWithTooltip))
  }
  onboardingType(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("onboardingType.id",
      "Pre-boarding type",
      this.common.getSelectFieldOptions(this.onBoardingTypes$, '', setAsRequired(additionalConfig)));
  }

  rank(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Rank', additionalConfig);
    return getSelectField(
      "globalRank.rankCode",
      "Rank",
      this.common.getGlobalRanks(
        setAsRequired(configWithTooltip))
      );
  }

  rankwithValue(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "job.rank",
      "Rank",
      this.common.getRankOptionsOnCountryCodewithValue(
        setAsRequired(additionalConfig))
    );
  }

  officeLocation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Office location', additionalConfig);
    return getSelectField(
      "officeLocation.id",
      "Office location",
      this.common.getSelectFieldOptions(this.officeLocation$, "",
        setAsRequired(configWithTooltip)
      )
    );
  }

  employeeCurrentLocation(additionalConfig?: FormlyFieldConfig, label = "Current office location"): FormlyFieldConfig {
    return getConfigurableTypeAhead("employeeCurrentLocation", label,
      this.addOfficeLocationTypeAheadEndPoint(additionalConfig)
    );
  }

  allEmployeeCurrentLocation(additionalConfig?: FormlyFieldConfig, label = "Current location"): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Current location', additionalConfig);
    return getConfigurableTypeAhead("employeeCurrentLocation", label,
      this.addAllOfficeLocationTypeAheadEndPoint(configWithTooltip)
    );
  }

  allEmployeeCurrentLocationMandatory(additionalConfig?: FormlyFieldConfig, label = "Current location"): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Current location', setAsRequired(additionalConfig));
    return getConfigurableTypeAhead("employeeCurrentLocation", label,
      this.addAllOfficeLocationTypeAheadEndPoint(configWithTooltip)
    );
  }

  allDependentCurrentLocation(additionalConfig?: FormlyFieldConfig, label = "Current location"): FormlyFieldConfig {
    return getConfigurableTypeAhead("dependentCurrentLocation", label,
      this.addAllOfficeLocationTypeAheadEndPoint(additionalConfig)
    );
  }
  OfficeLocationMissionVisaRenewal(additionalConfig?: FormlyFieldConfig, label = "Current location"): FormlyFieldConfig {
    return getConfigurableTypeAhead("officeLocation", label,
      this.addAllOfficeLocationTypeAheadEndPoint(additionalConfig)
    );
  }

  officeLE(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Legal entity name', additionalConfig);
    return getSelectField(
      "officeLE.id",
      label,
      this.common.getSelectActiveFieldOptionsWithFilter(this.officeLE$, '', setAsRequired(configWithTooltip))
    );
  }
  ksaOfficeLocation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('KSA Office location to be visited', additionalConfig);
    return getSelectField(
      "officeToBeVisited.id",
      "KSA Office location to be visited",
      this.common.getSelectFieldOptionsWithLE(this.officeLocation$, '', setAsRequired(configWithTooltip)))
  }
  officeLocationWithToolTip(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Office location', additionalConfig);
    return getSelectField(
      "officeToBeVisited.id",
      "Office location",
      this.common.getSelectFieldOptions(this.officeLocation$, '', setAsRequired(configWithTooltip)))
  }
  mobileNumber( additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Mobile number', additionalConfig);
    return getTelephoneField("Mobile number (KSA)",                             
      this.common.ValidateCountryCode("+966",setAsRequired(configWithTooltip)), 'col-md-4  pr-0 ');//{ wrappers: ['no-harm-error'] }
  }
  cityOfEmbassy( additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Embassy/Consulate (city)', additionalConfig);
    return  getInputField(
         "cityOfEmbassy",
         "Embassy/Consulate (city)",   
       setRequiredWhen((model) => (!isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1074),
      setRegexValidation(/^[a-zA-Z -]*$/,
        'Please enter a valid name',configWithTooltip)));
      }
       
  currentOfficeLocation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Current office location', additionalConfig);
    return getSelectField(
      "employeeCurrentLocationCountry.id",
      "Current office location",
      this.common.getSelectFieldOptions(this.nationality$, '',
        setDisableWhen((model) => (!isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id !== 1074),
          setRequiredWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id === 1074,
          configWithTooltip
          )
        ))
    )
  }
  configureOffLocation(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Office location', additionalConfig);
    return getSelectField(
      "officeLocation.id",
      label,
      this.common.getSelectFieldOptions(this.officeLocation$, "",
        setAsRequired(configWithTooltip)
      )
    );
  }

  grade(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "globalGrade.gradeCode",
      "Grade",
      this.common.getGlobalGrades(additionalConfig)
    );
  }

  gradewithValue(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "job.jobCode",
      "Grade",
      this.common.getGradesOnCountryCodewithValue(setAsRequired(additionalConfig))
    );
  }
previousNationality(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Previous nationality ', additionalConfig);
return getSelectField(
                "previousNationality.id",
                "Previous nationality",
                this.common.getSelectFieldOptions(this.nationality$, "",setRequiredWhen(
                  (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
                  setAsHiddenWithoutValueWhen(
                    (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false)
                  ,configWithTooltip))));
}
religion_DocumentSupportKSA(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Religion ', additionalConfig);
return getSelectField(
  "religion.id",
  "Religion",
  this.common.getSelectFieldOptions(this.religion$, "", setRequiredWhen(
    (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
    setAsHiddenWithoutValueWhen(
      (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false),configWithTooltip
    ))));
}
academicQalification(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Academic qualification ', additionalConfig);
return getInputField(
  "originalDegreeCertificate",
  //"Degree",
  "Academic qualification",
   setRequiredWhen( 
    (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
    setAsHiddenWithoutValueWhen(
      (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false),configWithTooltip)));
}
specialty(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('specialty ', additionalConfig);
return getInputField(
  "specialty",
  "Specialty",
  setRequiredWhen(
    (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
    setAsHiddenWithoutValueWhen(
      (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false),configWithTooltip)));
}
durationOfStudy(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Duration of study ', additionalConfig);
return getInputField(
  "durationofstudy",
  "Duration of study",
  setRequiredWhen(
    (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
    setAsHiddenWithoutValueWhen(
      (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false),configWithTooltip)));
}
visaIssuanceDateDocSupport(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Date of issuance ', additionalConfig);
return getDateField("visaIssuanceDate", "Date of issuance", setAsRequired(
  setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
    "Please enter a valid date in 'dd-mm-yyyy' format", 
    setAsHiddenWithoutValueWhen(
      (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id)),
     // this.common.AcceptDateAfter(0, "Date of issuance cannot be a past date", "Date of issuance", true,configWithTooltip),
    ),
  )));
}
issuingEntity(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Issuing entity ', additionalConfig);
return getInputField(
  "issuingEntity",
  "Issuing entity",
    setRequiredWhen(
    (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
    setAsHiddenWithoutValueWhen(
      (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false),configWithTooltip)));
}
issuingCountry(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Issuing country ', additionalConfig);
return getSelectField( 
                "issuingCountryId.id",
                "Issuing country",
                this.common.getSelectFieldOptions(this.nationality$,"", setRequiredWhen(
                  (model) => nullSafe(() => [14501,16113].includes(model.documentSupportType.id), false),
                  setAsHiddenWithoutValueWhen(
                    (model) => nullSafe(() => ![14501,16113].includes(model.documentSupportType.id), false),configWithTooltip))));
}

  requesterData(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getTypeAheadField("requestorData", "Requestor name", setAsRequired(additionalConfig));
  }
  residencyStatus(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "residencyStatus.id",
      "Residency status",
      this.common.getSelectFieldOptions(this.residencyStatus$, "",
        setAsRequired(additionalConfig))
    );
  }

  ptc(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('PJC name', additionalConfig);
    return getSelectField("ptc.id", "PJC name", setAsRequired(this.common.getEmployeeSelectFieldOptions(this.ptcs$, configWithTooltip)));
  }

  pjcName(label="PJC name",additionalConfig?: FormlyFieldConfig): FormlyFieldConfig{
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('PJC name', additionalConfig);
    return getSelectField("ptc.id", label, setAsRequired(this.common.getEmployeeSelectFieldOptions(this.ptcs$, configWithTooltip)));
  }
gpn(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GPN', additionalConfig);
    return getInputField(
      "gpn",
      "GPN",
      setRequiredWhen((model) => model.immigrationStatus.id === 5925,configWithTooltip)
    );
  }
  gui(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GUI', additionalConfig);
    return getInputField(
      "gui",
      "GUI",
      setRequiredWhen((model) => model.immigrationStatus.id === 5925,configWithTooltip)
    );
  }

  // gpnWithConditionalValidation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  //   let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GPN', additionalConfig);
  //   return getInputField(
  //     "gpn",
  //     "GPN",
  //     setRequiredWhen((model) => (model.immigrationStatus.id === 5925 && model.isMENAEmployee.id === 1074),configWithTooltip));
  // }
  // guiWithConditionalValidation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  //   let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GUI', additionalConfig);
  //   return getInputField(
  //     "gui",
  //     "GUI",
  //     setRequiredWhen((model) => (model.immigrationStatus.id === 5925 && model.isMENAEmployee.id === 1074),configWithTooltip)
  //   );
  // }
  mandatoryGpn(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GPN', additionalConfig);
    return getInputField(
      "gpn",
      "GPN",setAsRequired(configWithTooltip));
  }
  mandatoryGui(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GUI', additionalConfig);
    return getInputField(
      "gui",
    "GUI",setAsRequired(configWithTooltip));
  }
  nonMandatoryGpn(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GPN', additionalConfig);
    return getInputField(
      "gpn",
      "GPN",configWithTooltip);
  }
  nonMandatoryGui(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('GUI', additionalConfig);
    return getInputField(
      "gui",
    "GUI",configWithTooltip);
  }
  Religion(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Religion', additionalConfig);
    return getSelectField(
      "religion.id",
      "Religion",
      this.common.getSelectFieldOptions(this.religion$.pipe(map(x => x.filter(l => ![6628].includes(l.id)))), '',
        setAsRequired(configWithTooltip))
    );
    // return getInputField(
    //   "firstName",
    //   "First name (as per passport)",
    //   setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', configWithTooltip))
    // );
  }

  jobTitleGCCResident(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Job title', additionalConfig);
    return getInputField(
      "gccResidencyTitle",
      "Job title (GCC residents)",
      setDisableWhen((model) =>
        !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1075,
        setRequiredWhen((model) =>
          !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id != 1074,
        configWithTooltip),
      ),
    )
  
  }
  embassyConsulateCountry(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Embassy/Consulate (country) ', additionalConfig);
    return getSelectField(
      "embassy.id",
      "Embassy/Consulate (country)",
      this.common.getSelectFieldOptions(this.nationality$, '',
        setAsRequired(configWithTooltip))
      )
  
  }
  embassyConsulateCity(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Embassy/Consulate (city) ', additionalConfig);
    return getInputField(
      "cityOfEmbassy",
      "Embassy/Consulate (city)",
      setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/,
        'Please enter a valid name', configWithTooltip))
    )
  
  }

  ChargeCode(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Charge code ', additionalConfig);
    return getInputField(
      "chargeCode",
      "Charge code",
      this.common.ValidateChargeCode(
        '',
        setAsRequired(configWithTooltip))//{ wrappers: ['no-harm-error']}
    );
    // return getInputField(
    //   "firstName",
    //   "First name (as per passport)",
    //   setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', configWithTooltip))
    // );
  }
  EmpProfileSearch(additionalConfig?: FormlyFieldConfig, operations?): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Employee name lookup', additionalConfig);
    return getEmpProfileSelectField(
      "employeeSearchTerm",
      "Employee name lookup (only for MENA employees)",
      operations,
      configWithTooltip,
    );
  }

  // Requestor(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  //   return getInputField(
  //     "requestor.name",
  //     "Requestor name",
  //     setAsDisabled())
  // }

  RequestorName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "requestor.name",
      "Requestor name",
      setAsRequired(setAsDisabled()))
  }

  iqamaNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("iqamaNumber", "Iqama number",additionalConfig)
  }

  gpnGuiSearchButton(operations) {
    return !isNullOrUndefined(operations) ? this.button(operations, 'Autofill with GPN & GUI', 'outline-primary',
      setHideButtonWhen((model) =>
        !isUndefined(model['immigrationStatus'].id)
        && ![5920, 5923].includes(nullSafe<number>(() => model['immigrationStatus'].id, -1))
      )) : {}
  }

  visaProcessor(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "processor.id",
      "Immigration consultant",
         this.addFieldTooltipWithAdditionalConfig('Immigration consultant',
      setAsRequired(this.common.getEmployeeSelectFieldOptions(this.visaApprovers$, additionalConfig))));
  }


  visaAlignment(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "visaAlignment.id",
      "Visa alignment",
      this.common.getSelectFieldOptions(this.visaAlignment$, null)
    );
  }

  visaCancellationDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      'visaCancellationDate',
      'Visa cancellation date',
      this.addFieldTooltipWithAdditionalConfig('Visa cancellation date',setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null))))
  }
  EmploymentVisaCancellationDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      'employmentVisaCancellationDate',
      'Employment visa cancellation date',
      this.addFieldTooltipWithAdditionalConfig('Employment visa cancellation date', setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null))))
  }
  GVExpiryDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      'gvExpiryDate',
      'GV expiry date',
      this.addFieldTooltipWithAdditionalConfig( 'GV expiry date', setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null))))
  }


  guiFetch(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "gui",
      "GUI",
      setRequiredWhen((model) => model.immigrationStatus.id === 5925,additionalConfig)
    );
  }

  entryDate(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("entryDate", label, this.addFieldTooltipWithAdditionalConfig('Date of entry',setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format"))));
  }
  entryDateOptional(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("entryDate", label,setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format"));
  }  
  entryDateRequiredBasedOnStatus(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("entryDate", label, 
      this.addFieldTooltipWithAdditionalConfig(label,
        setRequiredWhen((model) => (model.immigrationStatus.id === ImmStatusType.APPROVED
                   || model.immigrationStatus.id === ImmStatusType.COMPLETED),
              setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              "Please enter a valid date in 'dd-mm-yyyy' format"))
      )
    );
  }

  missonVisaExpiryDate(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("missionExpiryDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format")));
  }

  immigrationStatus(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("immigrationStatus.id", "Immigration request status", this.common.getSelectFieldOptions(
      this.ImmStatus$.pipe(map(item => this.fil(item))), '',
      setDisablewithValueWhen((model)=>model.editCompletedProfile,setAsRequired(setImmStatusTypeValidation("Please change status before saving", { name: "statustype" })) )
      ));
  }

  passportExpiryDate(label = 'Passport expiry', additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent passport expiry date' : label, additionalConfig);
    return getDateField("passportExpiryDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format",
        this.common.AcceptDateAfter(0, 'Passport expiry date cannot be a past date', 'Passport expiry', true, configWithTooltip))));
  }
  dateOfTravel(label = 'Date of travel', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("dateOfTravel", label,this.common.validateJorDateOfTravel('Date of travel',additionalConfig));
  }
  passportExpiryDateOptional(label = 'Passport expiry', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("passportExpiryDate", label,setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format",
        this.common.AcceptDateAfter(0, 'Passport expiry date cannot be a past date', 'Passport expiry', true, additionalConfig)));
  }

  passportExpiryDateWithoutValidation(label = 'Passport expiry', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("passportExpiryDate", label, this.addFieldTooltipWithAdditionalConfig('Passport expiry date',setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format"))));
  }
  currentKSABusinessVisaExpiryDate(label = 'Expiry date of Current KSA business visa', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    additionalConfig = getMergedConfig(this.common.AcceptDateBeforeWithoutPastDate(7, "To apply for a new KSA business visa, the current visa's validity must be less than 7 days"),
      additionalConfig);
    return getDateField("currentKSABusinessVisaExpiryDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format",
        additionalConfig)));
  }
  visaProcessorByOfficeLocation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Immigration consultant', additionalConfig);
    return getSelectField(
      "processor.id",
      "Immigration consultant",
      this.common.getEmployeeByOfficeLocationSelectFieldOptions(
        this.visaApprovers$, RoleType.VisaApprover, configWithTooltip));
  }

  ptcByOfficeLocation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "ptc.id",
      "PTC name (Preboarding Team)",
      this.common.getEmployeeByOfficeLocationSelectFieldOptions(
        this.ptcs$, RoleType.PTC, additionalConfig));
  }

  ptcByCountry(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "ptc.id",
      "PJC name",
      this.common.getEmployeeByRoleInCountrySelectFieldOptions(RoleType.PTC,setAsRequired(additionalConfig))
    );

  }


  visaProcessorByOfficeLE(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Immigration consultant', additionalConfig);
   return getSelectField(
      "processor.id",
      "Immigration consultant",
      this.common.getEmployeeByOfficeLESelectFieldOptions(
        this.visaApprovers$, RoleType.VisaApprover, configWithTooltip));
  }
  visaProcessorByOLE(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {   
  
    return this.visaProcessorByOfficeLE(setAsRequired());

  }

  nameOfNewEmployer(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "nameOfNewEmployer",
      "Name of new employer",
      setAsRequired(additionalConfig)
    );
  }

  lastWorkingDay(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Last working day', additionalConfig);
    return getDateField("lastWorkingDay", "Last working day", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip))
    );
  }

  travelDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Date of travel', additionalConfig);
    return getDateField(
      "dateOfTravel",
      "Date of travel",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format",
          this.common.AcceptDateAfter(4, 'Travel date should be atleast 5 days from today', 'Date of travel', true, configWithTooltip))));
  }
  travelDateQAT(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "dateOfTravel",
      "Date of travel",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format",
          this.common.AcceptDateAfter(6, 'Travel date should be atleast 7 days from today', 'Date of travel', true))));
  }

  travelDateAfter(days: number, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Date of travel', additionalConfig);
    return getDateField(
      "dateOfTravel",
      "Date of travel",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format",
          this.common.AcceptDateAfter(days, `Travel date should be atleast ${days + 1} days from today`, 'Date of travel', true, configWithTooltip))
      )
    );
  }  

  exitDate(label = 'Final date of exit', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(label, additionalConfig);
    return getDateField(
      "dateOfExit",
      label,
      this.common.isDateGreaterThanDate((date, dateToCompare) => isAfter(date, dateToCompare),
        "Final Date of exit must be greater than date of travel", 'dateOfTravel',
        setAsRequired(
          setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
            "Please enter a valid date in 'dd-mm-yyyy' format",configWithTooltip))));
  }
  reasonForVisit(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Reason for visit', additionalConfig);
    return getInputField(
      "reason",
      "Reason for visit",
      setAsRequired(
        configWithTooltip
      )
    );
  }

  visaAgent(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "visaAgentName",
      "Visa agent name",
      setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/,
        'Please enter a valid name', additionalConfig))
    );
  }

  button(operations: () => string[], buttonLabel: string, btnType: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getJustaButton(operations, buttonLabel, btnType, additionalConfig);
  }

  visaIssuanceDate(label = "Date of visa issuance", additionalConfig?: FormlyFieldConfig ,isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent visa issuance date':'Date of visa issuance', additionalConfig);
    return getDateField(
      "visaIssuanceDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip)));
  }  

  visaIssuanceDateVAS(label : string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(label, additionalConfig);
    return getDateField(
      "visaIssuanceDate",
      label,        
      setRequiredWhen((model) => model.countryToBeVisited.id === CountryTypeIds.SaudiArabia 
                  && (model.immigrationStatus.id === ImmStatusType.APPROVED
                    || model.immigrationStatus.id === ImmStatusType.COMPLETED),
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
            "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip))      
    )
  }

  visaValidityDate(label = "Visa Validity Date", additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Visa expiry date', additionalConfig);
    return getDateField(
      "visaValidityDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip)));
  }

  workPermitpreApprovalDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "workPermitPreApprovalDate",
      "Work permit pre-approval date",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }

  transferApprovalDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "transferApprovalDate",
      "Transfer approval date",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }

  dateOfGatePassIssuance(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "dateOfGatePassIssuance",
      "Date of gate pass issuance ",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }

  VisaExpiryDate(label = 'Visa expiry date', additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let tooltipText = label == 'GV Expiry Date' ? 'GV expiry date' : label;
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent visa expiry date' : tooltipText, additionalConfig);
    return getDateField(
      "visaExpiryDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip)));
  }

  VisaExpiryDateVAS(label : string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {    
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(label, additionalConfig);
    return getDateField(
      "visaExpiryDate",
      label,
      setRequiredWhen((model) => model.countryToBeVisited.id == CountryTypeIds.SaudiArabia 
                  && (model.immigrationStatus.id === ImmStatusType.APPROVED
                    || model.immigrationStatus.id === ImmStatusType.COMPLETED),
              setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              "Please enter a valid date in 'dd-mm-yyyy' format", configWithTooltip))
    );
  }

  VisaExtensionDate(label = 'Visa extension date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "visaExtensionDate",
      label,
      this.addFieldTooltipWithAdditionalConfig('Visa extension issuance date',
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig))));
  }


  uidNumber(label = 'UID number', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(label, additionalConfig);
    return getInputField(
      'uid',
      label, setAsRequired(configWithTooltip));
  }

  perDiem(label = 'Per Diem', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      'perDiem',
      label);
  }

  fileNumber(label = 'File number', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      'fileNumber',
      label, setAsRequired(additionalConfig));
  }

  emiratesId(label = 'Emirates id', additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent emirates id' :'Emirates id number', additionalConfig);
    return getInputField(
      'emiratesIdNumber',
      label,
      setRegexValidation(/^[0-9]{3}-[0-9]{4}-[0-9]{7}-[0-9]{1}$/,
        "Please enter a valid emirates id in the format 000-0000-0000000-0", configWithTooltip)
    );
  }

  maritalStatus(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "maritalStatus.id",
      "Marital status",
      this.common.getSelectFieldOptions(this.maritalStatus$, '', setAsRequired(this.addFieldTooltipWithAdditionalConfig('Marital status'))));
  }

  rpNumber(label = 'RP number', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "rpNumber",
      label,
      setAsRequired(additionalConfig)
    );
  }
  rpExpiryDate(label = "RP expiry date", additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(label, additionalConfig);
    return getDateField(
      "rpExpiryDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format",configWithTooltip //additionalConfig
          //,this.common.AcceptDateAfter(0, "RP expiry date cannot be a past date", 'RP expiry date', true)
          )));
  }
  newRpExpiryDate(label = "New RP expiry date", additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "newRPExpiryDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format",additionalConfig
          )));
  }
  quotaValidityDate(label = 'Quota validity date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "quotaValidityDate",
      label,
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig));
  }

  civilIdExpiryDate(label = "Civil id expiry date", additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "civilIdExpiryDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)));
  }


  rpRenewalDate(label = "RP renewal date", additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "rpRenewalDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }
  cprExpiryDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "cprExpiryDate",
      "CPR expiry date",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format"
          //,this.common.AcceptDateAfter(0, "CPR expiry date cannot be a past date", 'CPR expiry date', true)
          )));
  }
  rpIssuanceDate(label = 'RP issuance date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "rpIssuanceDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format",additionalConfig)));
  }
  extensionIssuanceDate(label = 'Extension issuance date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "extensionIssuanceDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }

  workPermitExpiryDate(label = 'Work permit expiry date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "workPermitExpiryDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }
  cprIssuanceDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "cprIssuanceDate",
      "CPR issuance date",
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }
  relationships(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("relationship.id", "Relationship",
      setAsRequired(this.common.getSelectFieldOptions(this.relationship$, '', additionalConfig)));
  }

  currentVisaStatus(label = "Current visa status", additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent current visa status' :'Current visa status', additionalConfig);
    return getSelectField(
      "visaStatus.id",
      label,
      this.common.getSelectFieldOptions(this.currentVisaStatus$, '', setAsRequired(configWithTooltip)));
  }

  cprNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("cprNumber", "CPR number", additionalConfig);
  }

  borderNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
    "borderNumber",
    "Border number",
      additionalConfig);
  }

  trackingNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
    "trackingNumber",
    "Courier Tracking number",
      additionalConfig);
  }

  gosiTerminationDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("gosiTerminationDate", "GOSI termination date",
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)
    );
  }
  BusinessvVisaExitDate(label = 'Exit Date', days: number, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("dateOfExit", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format",
        this.common.checkDateDifference((date, dateToCompare) => differenceInDays(date, dateToCompare),
          days, " Date of exit must be greater than " + days + " days from date of entry", 'entryDate',
          this.common.AcceptDateAfter(0, 'Exit date cannot be a past date', 'Exit Date', true, additionalConfig)))));
  }
  gracePeriodExpiryDate(label = 'Grace period expiry date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("gracePeriodExpiryDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format",
        this.common.AcceptDateAfter(0, 'Grace period expiry date cannot be a past date', 'Grace period expiry date', true, additionalConfig))));
  }
  workPermitIssuanceDate(label = 'Work permit issuance date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("workPermitIssuanceDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }
  workPermitCancellationDate(label = 'Work permit cancellation date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("workPermitCancellationDate", label, this.addFieldTooltipWithAdditionalConfig('Work permit cancellation date',setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", null))));
  }
  PIFSSCancellationDate(label = 'PIFSS cancellation date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("pifssCancellationDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }

  IBANNumber(label = 'IBAN number', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      'ibanNumber',
      label, setAsRequired(additionalConfig));
  }
  IBANNumberOptional(label = 'IBAN number', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      'ibanNumber',
      label,additionalConfig);
  }

  PersonalEmailAddress(label = 'Employee Personal email ID', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField('personalEmailAddress', label, this.addFieldTooltipWithAdditionalConfig('Personal email id', setAsRequired(
      setRegexValidation(
        ///^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        /^\w+([\.]?[\-\_\w+])*@\w+([\.-]?\w+)*(\.\w{2,})(?<!\.ey.com)$/,
        'Please enter a valid email address',
        null))));
  }
  PersonalEmailAddressOptional(label = 'Employee Personal email ID', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Personal email address', additionalConfig);
    return getInputField('personalEmailAddress', label, 
      setRegexValidation(
        ///^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        /^\w+([\.]?[\-\_\w+])*@\w+([\.-]?\w+)*(\.\w{2,})(?<!\.ey.com)$/,
        'Please enter a valid email address',
        configWithTooltip));
  }

  EYEmailAddress(label = 'Employee EY email ID', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Email id', additionalConfig);
    return getInputField("eyEmailAddress", label,
      setRegexValidation(
        /^[A-Za-z0-9._%+-@]+ey.com$/,
        'Please enter a valid EY email',
        setDisableWhen(null, configWithTooltip)));
  }

  EmployeeEmailId(){
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Employee email id');
    return  getTypeAheadField(
              "immEmployee",
              "Employee email ID",
              setRequiredWhen((model) => !isNullOrUndefined(model.onBehalfOfAnotherEYEmployee) && model.onBehalfOfAnotherEYEmployee.id === 1074,configWithTooltip)
            )
  }

  firmJoiningDate(label = 'Joining Date',additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("joiningDate", "Joining date", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)));
  }
  
  dateDocumentAttestationCompleted(label ='Date document attestation completed',additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("dateDocumentAttestationCompleted", "Date document attestation completed", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)));
  }

  SICancellationDate(label = 'SI Cancellation Date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("siCancellationDate", label, setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", null)));
  }

  lastWorkingDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("lastWorkingDate", "Last working date", 
      this.addFieldTooltipWithAdditionalConfig('Last working day',
      setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)))
    );
  }
   secondNationality(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
     return getSelectField("secondNationality", "Second Nationality", 
     this.common.getSelectFieldOptions(this.nationality$, '',
      setAsRequired(additionalConfig)));
  }
  socialInsuranceNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("socialInsuranceNumber", "Social insurance number", 
      this.addFieldTooltipWithAdditionalConfig('Social insurance number',setAsRequired(additionalConfig)));
  }
  DependentFinalExitStatusChangeDate(label = 'Dependent Final exit/status change deadline',additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      'dependentFinalExitDeadline',
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format", null)))
  }
  nationalityTypeWithoutExpact(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig{
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Nationality type', additionalConfig);
    return getSelectField(
      "nationalityType.id", "Nationality type",
      this.common.getSelectFieldOptions(this.nationalityType$.pipe(map(item => item.filter(i => 
        [14571,14572,14573].includes(i.id)))),'',setAsRequired(configWithTooltip)));
  }
  nationalityTypeWithFamilyBook(additionalConfig?: FormlyFieldConfig, isDependent = false): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig(isDependent ? 'Dependent nationality type' :'Nationality type', additionalConfig);
    return getSelectField(
    "nationalityType.id", "Nationality type",
    this.common.getSelectFieldOptions(this.nationalityType$.pipe(map(item => item.filter(i => 
      [14570,14571,14572,14573].includes(i.id)))),'',setAsRequired(configWithTooltip)));
  }
  nationalityType(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Nationality type', additionalConfig);
    return getSelectField(
      "nationalityType.id", "Nationality type",
      this.common.getSelectFieldOptionsWithDisable(this.nationalityType$.pipe(map(item => item.filter(i => 
            [14570,14571,14572,14573].includes(i.id)))), [14573],setAsRequired(configWithTooltip)));
  }
  nationalityTypeWithSpecialExpact(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Nationality type', additionalConfig);
    return getSelectField(
    "nationalityType.id", "Nationality type",
    this.common.getSelectFieldOptionsWithDisable(this.nationalityType$.pipe(map(item => item.filter(i => 
      [14570,14571,14572,15233,14573].includes(i.id)))), [14573],setAsRequired(configWithTooltip)));
  }
  contractDuration(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Labour contract duration', additionalConfig);
    return getInputField("contractDuration", "Labour contract duration (months)", setAsRequired(
      setAsNumeric(checkRange(0,36,
        "Labour contract duration(months) should not be more than 36 months", configWithTooltip)))
    );
  }
  labourPersonCode(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Labour person code', additionalConfig);
    return getInputField("labourPersonCode", "Labour person code", 
    setAsRequired
    (configWithTooltip));
  }
  mohreJobTitle(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("mohreJobTitle", "Work permit job title", 
    setAsRequired
    (additionalConfig));
  }
  mohreJobTitleId(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Work permit job title', additionalConfig);
    return getSelectField("mohreJobTitleId.id", "Work permit job title", 
      this.common.getSelectFieldOptions(this.workpermitJobTitles$, '',
        setAsRequired(configWithTooltip)));
  }
  workPermitCategory(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("workPermitCategory", "Work permit category",
      this.common.getWPDetailsFromJobTitle(setAsDisabled()));
  }
  workPermitJobCode(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("workPermitJobCode", "Work permit job code",
      this.common.getWPDetailsFromJobTitle(setAsDisabled()));
  }
  labourCardNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Labour card number', additionalConfig);
    return getInputField("laborCardNumber", "Labour card number", setAsRequired(configWithTooltip));
  }

  typeOfVisa(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Visa type', additionalConfig);
    return getSelectField(
      "typeOfVisa.id", "Visa Type",
      this.common.getSelectFieldOptions(this.typeOfVisa$.pipe(map(x => x.filter(l => ![15255,15256].includes(l.id)))), '',
      setAsRequired
      (configWithTooltip)));
  }

  noticePeriod(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("noticePeriod", "Notice Period (MOL)",
    setDisableWhen((model) =>
    !isNullOrUndefined(model.officeLE) && ![673,674,676,680,722].includes(model.officeLE.id),
    setRequiredWhen((model) =>
      !isNullOrUndefined(model.officeLE) && [673,674,676,680,722].includes(model.officeLE.id),
      setAsNumeric(checkRange(0,6,
        "Notice Period (MOL) should not be more than 6 months", additionalConfig)))
    ));
 
  }


  typeOfWorkPermit(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Type of work permit', additionalConfig);
    return getSelectField(
      "typeOfWorkPermit.id",
      "Type of Work Permit",
      this.common.getSelectFieldOptions(this.typeOfWorkPermit$, '', setAsRequired(configWithTooltip))
    );
  }
 
  visaDesignation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Visa designation', additionalConfig);
    return getInputField(
      "visaDesignation",
      "Visa designation",
      configWithTooltip
    );
  }
  LabourContractNoticePeriod(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Labour contract notice period', additionalConfig);
    return getInputField(
      "labourContractNoticePeriod",
      "Labour Contract Notice Period (months)",
      setDisableWhen((model) =>
      !isNullOrUndefined(model.officeLE) && ![673,674,676,680,722].includes(model.officeLE.id),
      setRequiredWhen((model) =>
        !isNullOrUndefined(model.officeLE) && [673,674,676,680,722].includes(model.officeLE.id),
        setAsNumeric(checkRange(0,6,
          "Labour contract notice period(months) should not be more than 6 months", configWithTooltip)))
      ));
   
    }
    molContract(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
      let configWithTooltip = this.addFieldTooltipWithAdditionalConfig('Type of MOL contract', additionalConfig);
    return getSelectField(
      "molContract.id",
      "Type of MOL Contract",
      this.common.getSelectFieldOptionsWithDisable(this.molContract$.pipe(map(item => item.filter(i => [6624,6625,6626,6627].includes(i.id)))), [6626,6627],
      setAsRequired(configWithTooltip))
    );
  }

  loadCandidateLookups() {

    this.ptcs$ = this.common.prepareEmployeeByRoleObservable(RoleType.PTC);

    this.nationality$ = this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY
    );

    this.gender$ = this.common.prepareLookupObservable(
      LookupTypeKeys.GENDER
    );

    this.officeLocation$ = this.common.prepareOfcLocationsWithCountryCode();
    //same Api as officeLocation$
    this.officeLocationWithBehaviourSub$ = this.common.prepareOfcLocationsWithCountryCodeAsBehaviourSub();
    this.missionVisaCategoryWithBehaviourSub$ = this.common.prepareMissionVisaCateogryAsBehaviourSub();
    this.categoryOfJobOfferWithBehaviourSub$ = this.common.prepareCategoryOfJobOfferAsBehaviourSub();
    this.visaAlignment$ = this.officeLocation$;
    this.officeLE$ = this.common.prepareOfcLEWithConCode();
    this.officeLegalEntities$ = this.common.prepareOfficeEntityObservable();
    this.ksaOfficeLocation$ = this.common.prepareKSAOfcLocationsWithCountryCode();
    this.KsaLegalEntities$ =  this.common.prepareKSALegalEntitiesWithCountryCode();
    this.allOfficeLocation$ = this.common.GetAllOfficeLocation();
    this.allOfficeLocationCountry$ = this.common.GetOfficeLocationsAllCountries();
    this.allForeignOfficeLocation$ = this.common.GetAllForeignOfficeLocation();

    this.serviceLines$ = this.common.prepareServiceLineObservable();
    this.subServiceLines$ = this.common.prepareSubServiceLineObservable();
    this.subSubServiceLines$ = this.common.prepareSMUObservable();
    this.workpermitJobTitles$ = this.common.prepareWorkPermitJobTitleObservable();
    this.ranks$ = this.common.prepareLookupObservable(LookupTypeKeys.RANK);
    this.officeLocationCountry$ = this.common
  .prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION_COUNTRY)
  .pipe(
    map(items => items.filter(item => item.id !== 16203))
  );
      this.workLocationDuringTrip$ = this.common.prepareLookupObservable(
      LookupTypeKeys.WORKL_LOCATION_DURING_TRIP
    );
    this.onBoardingTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.ONBOARDING_TYPES
    );

    this.immigrationCaseType$ = this.common.prepareLookupObservable(
      LookupTypeKeys.IMMIGRATION_CASE_TYPE
    );

    this.immigrationCaseTypeTempPartWP_ARE$ = this.common.prepareLookupObservable(
      LookupTypeKeys.IMMIGRATION_CASE_TYPE
    );

    this.immigrationCaseTypeVisaPreApproval$ = this.common.prepareImmCaseTypeObservable(
      LookupTypeKeys.IMMIGRATION_CASE_TYPE
    );

    this.immigrationCaseType$ = this.immigrationCaseType$.pipe(map(item => this.filiterCaseTypeExcludeByIds(item, [12266, 12267, 12268, 12269, 12320])));

    this.immigrationCaseTypeTempPartWP_ARE$ = this.immigrationCaseTypeTempPartWP_ARE$.pipe(map(item => this.filiterCaseTypeExcludeByIds(item, [12266, 12267, 12268, 12269])));

    this.transferScenario$ = this.common.prepareLookupObservable(
      LookupTypeKeys.TRANSFER_SCENARIO
    );

    this.entryType$ = this.common.prepareLookupObservable(
      LookupTypeKeys.ENTRY_TYPE
    );
     this.getVisaDuration$ = this.common.prepareLookupObservable(
      LookupTypeKeys.VISA_DURATION
    );
     this.purposeOfVisit$ = this.common.prepareLookupObservable(
      LookupTypeKeys.PURPOSE_OF_VISIT
    ); 
    
    this.residencyStatus$ = this.common.prepareLookupObservable(
      LookupTypeKeys.RESIDENCY_STATUS
    );

    this.businessVisaDurationOfStay$ = this.common.prepareLookupObservable(
      LookupTypeKeys.BUSINESS_VISA_DURATION_OF_STAY
    );
    this.employeeCategorys$ = this.common.prepareLookupObservable(
      LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES
    );
    this.typeOfEmployment$ = this.common.prepareLookupObservable(
      LookupTypeKeys.TYPE_OF_EMPLOYMENT
    );

    this.globalEmployeeLocationCountries$ = this.common.prepareLookupObservable(
      LookupTypeKeys.EMPLOYEE_CURRENT_LOCATION_COUNTRY
    );
    this.yesNo$ = this.common.prepareLookupObservable(
      LookupTypeKeys.YESNO_TYPES
    );
      this.accommodationRequired$ = this.common.prepareLookupObservable(
      LookupTypeKeys.ACCOMMODATION_TYPES
    );
    
    this.requestedServices$ = this.common.prepareLookupObservable(
      LookupTypeKeys.REQUESTED_SERVICES
    );
   
    this.yesNoNa$ = this.common.prepareLookupObservable(
      LookupTypeKeys.YESNONA_TYPES
    );
    this.nationalityType$ =this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY_TYPE
    );


    this.ImmStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_STATUSES);

    this.recruiters$ = this.common.prepareEmployeeByRoleObservable(RoleType.Recruiter);
    this.employees$ = this.common.prepareEmployeeByRoleObservable(RoleType.Employee);
    this.localHre$ = this.common.prepareEmployeeByRoleObservable(RoleType.LocalHRE);

    this.visaApprovers$ = this.common.prepareEmployeeByRoleObservable(RoleType.VisaApprover);
    this.preboardingType$ = this.common.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES);
    this.cancellationReason$ = this.common.prepareLookupObservable(LookupTypeKeys.CANCELLATION_REASON);
    this.passportType$ = this.common.prepareLookupObservable(LookupTypeKeys.PASSPORT_TYPES);

    this.gosiRemovalRequesters$ = this.common.GetUsersByClaimValue('SAU-GOSIremoval-Create', CountryTypesValues.SaudiArabia);
    this.gosiAdditionRequestors$ = this.common.GetUsersByClaimValue('SAU-GOSIadditional-Create', CountryTypesValues.SaudiArabia);
    this.visaCancellationRequestors$ = this.common.GetUsersByClaimValue('SAU-VisaCancellation-Create', CountryTypesValues.SaudiArabia);
    this.visaPreApprovalrequestors$ = this.common.GetUsersByClaimValue('SAU-VisaPreApproval-Create', CountryTypesValues.SaudiArabia);
    this.exitIqamaTransfer$ = this.common.GetUsersByClaimValue('SAU-ExitIqamatransfer-Create', CountryTypesValues.SaudiArabia);
    this.omnWorkPermitPreApproval$ = this.common.GetUsersByClaimValue('OMN-OMN-WorkPermitPreAprroval-Create', CountryTypesValues.OMAN);

    this.tawteenRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-Tawteen-Create', CountryTypesValues.UAE);
    this.laborCardCancellationRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-LabourCardCancellation-Create', CountryTypesValues.UAE);
    this.visaCancellationInsideRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-VisaCancellationInside-Create', CountryTypesValues.UAE);
    this.visaCancellationOutsideRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-VisaCancellationOutside-Create', CountryTypesValues.UAE);
    this.dependentsVisaIssuanceRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-DependentsVisaIssuance-Create', CountryTypesValues.UAE);
    this.dependentsVisaRenewalRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-DependentsVisaRenewal-Create', CountryTypesValues.UAE);
    this.depVisaGccMarriedToExpatRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-DepVisaGccMarriedToExpat-Create', CountryTypesValues.UAE);
    this.employmentVisaRenewalRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-EmploymentVisaRenewal-Create', CountryTypesValues.UAE);



    this.PensionRemovalRequesters$ = this.common.GetUsersByClaimValue('ARE-ARE-PensionRemoval-Create', CountryTypesValues.UAE);

    this.enrollmentType$ = this.common.prepareLookupObservable(LookupTypeKeys.ENROLLMENT_TYPE);
    this.workTimings$ = this.common.prepareLookupObservable(LookupTypeKeys.WORK_TIMING);
    this.language$ = this.common.prepareLookupObservable(LookupTypeKeys.LANGUAGES);
    this.workWeek$ = this.common.prepareLookupObservable(LookupTypeKeys.WORK_WEEK);
    this.jobBenefits$ = this.common.prepareLookupObservable(LookupTypeKeys.JOB_BENEFITS);
    this.religion$ = this.common.prepareLookupObservable(LookupTypeKeys.RELIGION);
    this.sect$ = this.common.prepareLookupObservable(LookupTypeKeys.SECT);
    this.missionVisaType$ = this.common.prepareLookupObservable(LookupTypeKeys.HIGHER_LOWER);
    this.molContract$ = this.common.prepareLookupObservable(LookupTypeKeys.MOL_CONTRACT);
    this.maritalStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.MARITAL_STATUS);
    this.shortTermVisa$ = this.common.prepareLookupObservable(LookupTypeKeys.SHORT_TERM_VISA);
    this.relationship$ = this.common.prepareLookupObservable(LookupTypeKeys.RELATIONSHIPS);
    this.typeOfRequest$ = this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_REQUEST);
    this.currentVisaStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.CURRENT_VISA_STATUS);
    this.cprCaseType$ = this.common.prepareLookupObservable(LookupTypeKeys.CPR_CASE_TYPE);
    this.cprType$ = this.common.prepareLookupObservable(LookupTypeKeys.CPR_TYPE);
    this.reasonForVisit$ = this.common.prepareLookupObservable(LookupTypeKeys.REASON_FOR_VISIT);
    this.requiredAttestation$ = this.common.prepareLookupObservable(LookupTypeKeys.REQUIRED_ATTESTATION);
    this.processingTeam$ = this.common.prepareLookupObservable(LookupTypeKeys.PROCESSING_TEAM);
    this.processingBy$ = this.common.prepareLookupObservable(LookupTypeKeys.PROCESSING_BY);
    this.JORReasonForVisit$=this.common.prepareLookupObservable(LookupTypeKeys.REASON_FOR_VISIT_JOR);
    this.hireType$ = this.common.prepareLookupObservable(LookupTypeKeys.HIRE_TYPE);
    this.permitType$ = this.common.prepareLookupObservable(LookupTypeKeys.PERMIT_TYPE);
    this.bloodGroup$ = this.common.prepareLookupObservable(LookupTypeKeys.BLOOD_GROUP);
    this.typeOfSupport$ = this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_SUPPORT);
    this.typeOfModifcation$ = this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_MODIFCATION);
    this.missionVisaCategory$ = this.common.prepareLookupObservable(LookupTypeKeys.MISSION_VISA_CATEGORY);
    this.academicQualification$ = this.common.prepareLookupObservable(LookupTypeKeys.ACADEMIC_QUALIFICATION);
    this.categoryOfJobOffer$ = this.common.prepareLookupObservable(LookupTypeKeys.CATEGORY_OF_JOBOFFER);
    this.reasonForVisitUAE$ = this.common.prepareLookupObservable(LookupTypeKeys.REASON_FOR_VISIT_UAE_BV);
    this.reasonForRenewal$ = this.common.prepareLookupObservable(LookupTypeKeys.REASON_FOR_RENEWAL);
    this.travelType$ = this.common.prepareLookupObservable(LookupTypeKeys.TRAVEL_TYPE);
    this.nomination$ = this.common.prepareLookupObservable(LookupTypeKeys.NOMINATION);
    this.labourcardcancellationtype$ = this.common.prepareLookupObservable(LookupTypeKeys.LABOUR_CARD_CANCELLATION_TYPE);
    this.terminationtype$ = this.common.prepareLookupObservable(LookupTypeKeys.TERMINATION_TYPE);
    this.travelPurpose$ = this.common.prepareLookupObservable(LookupTypeKeys.SHORT_TRAVEL_TYPE);
    this.noofexteniontimes$ = this.common.prepareLookupObservable(LookupTypeKeys.No_Of_Extension_Times);
    this.VaccinationStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.VACCINATION_STATUS_IMM).pipe(map(items => items.sort((a, b) => a.order - b.order))),
    this.VaccineType$ = this.common.prepareLookupObservable(LookupTypeKeys.VACCINE_TYPE)
    this.typeOfDocRequested$ = this.common.prepareLookupObservable(LookupTypeKeys.TypeOfDocRequested)
    this.documentSupportType$ = this.common.prepareLookupObservable(LookupTypeKeys.DocumentSupportType).pipe(map(items => items.sort((a, b) => a.order - b.order)))
    this.citizenship$ = this.common.prepareLookupObservable(LookupTypeKeys.CITIZENSHIP);
    this.reasonForVisitPAK$ =this.common.prepareLookupObservable(LookupTypeKeys.REASON_FOR_VISIT_PAK_BV);
    this.pakOfficeToVisit$ =this.common.prepareLookupObservable(LookupTypeKeys.OFFICETOVISIT_PAK_BV);
    this.typeOfVisa$ =this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_VISA);
    this.typeOfVisaRequired$ =this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_VISA_Required);
    this.typeOfWorkPermit$ =this.common.prepareLookupObservable(LookupTypeKeys.WORK_PERMIT_TYPE);
    this.primeType$ = this.common.prepareLookupObservable(LookupTypeKeys.PRIME_TYPE);
  }

  fil(item: LookupField[]): LookupField[] {
    item = item.filter(i =>
      i.id !== ImmStatusType.PENDING
      && i.id !== ImmStatusType.DRAFT
      && i.id !== ImmStatusType.DECLINED
      && i.id !== ImmStatusType.WITHDRAWN
    );
    item.find(i => i.id === ImmStatusType.COMPLETED).disabled = true;
    return item;
  }

  filiterCaseType(item: LookupField[]): LookupField[] {
    item = item.filter(i => [1005, 1016, 1017, 12266, 12267, 12268, 12269].includes(i.id))
      .sort((a, b) => a.order - b.order);
    return item;
  }

  filiterCaseTypeByIds(item: LookupField[], ids: number[]): LookupField[] {
    item = item.filter(i => ids.includes(i.id));
    return item;
  }

  filiterCaseTypeExcludeByIds(item: LookupField[], ids: number[]): LookupField[] {
    item = item.filter(i => !ids.includes(i.id));
    return item;
  }

  

  AddTooltipToControl(tooltipMessage: string): FormlyFieldConfig {
    return {
      templateOptions: {
        tooltip: {
          content: tooltipMessage
        }
      },
      wrappers: ['tooltip-field']
    };
  }


  AddTooltipToControlWithAdditionalConfig(tooltipMessage: string, additionalConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        tooltip: {
          content: tooltipMessage
        }
      },
      wrappers: ['tooltip-field']
    };
    return getMergedConfig(config, additionalConfig);
  }

  addOfficeLocationTypeAheadEndPoint(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        typeAheadEndPoint: (x) => this.common.getOfficeLocations(x)
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  addAllOfficeLocationTypeAheadEndPoint(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        typeAheadEndPoint: (x) => this.common.getAllOfficeLocations(x)
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


  getGCCNationalCountryIds(): number[] {
    return [241, 203, 188, 175, 127, 26];
  }

  addFieldTooltipWithAdditionalConfig(tooltipField: string, additionalConfig?: FormlyFieldConfig, isMultipleWrappers = false): FormlyFieldConfig {
    let config: FormlyFieldConfig = additionalConfig || {};
      const tooltipTextObj = this.common.fieldToolTipTextsByVisa?.find(x => x.fieldName.toLowerCase().trim() === tooltipField.toLowerCase().trim());
    if (tooltipTextObj) {
      const tooltipConfig: FormlyFieldConfig = {
        templateOptions: {
          tooltip: {
            content: tooltipTextObj.toolTipText,
            isToolTipAdjustRequired : tooltipField == 'Mobile number' || tooltipField == 'Emergency contact number' ? true : false,
          }
        },
          wrappers: isMultipleWrappers ? ['tooltip-field','no-harm-error'] : ['tooltip-field']
      };
      config = getMergedConfig(tooltipConfig, config);
    }
    return config;
  }
}
